import { TextField, TextFieldProps } from "@mui/material";
import { useEffect, useState } from "react";

interface IProps {
	value: any;
	onSetValue(value: any): void;
	inputProps?: TextFieldProps;
	className?: string;
	multiline?: boolean;
}

const EditText = (props: IProps) => {
	const [value, setValue] = useState<string>("");

	useEffect(() => {
		setValue(props.value);
	}, [props.value]);

	return (
		<TextField
			multiline={props.multiline}
			className={props.className || ""}
			value={value}
			variant={"standard"}
			{...props.inputProps}
			onChange={(e) => {
				setValue(e.target.value);
			}}
			onKeyDown={(e) => {
				if (e.key === "Enter") {
					props.onSetValue(value);
				}
			}}
			onBlur={() => {
				props.onSetValue(value);
			}}
		/>
	);
};

export default EditText;
